import { isEmpty } from "lodash";
import { DEFAULT_LANGUAGE } from "../language";
import { toJSON } from "../utils";
export var EmailTemplateType;
(function (EmailTemplateType) {
    EmailTemplateType["PAYMENT_CONFIRMED"] = "paymentConfirmed";
    EmailTemplateType["PAYMENT_FAILED"] = "paymentFailed";
    EmailTemplateType["REDEEM_CODE"] = "redeemCode";
    EmailTemplateType["AIRDROP_RECEIVED"] = "airdropReceived";
})(EmailTemplateType || (EmailTemplateType = {}));
export class NFTEventTierEmailConfig {
    constructor(params) {
        if (isEmpty(params.templates)) {
            this.templates = {};
            for (const type of Object.values(EmailTemplateType)) {
                this.templates[type] = { [DEFAULT_LANGUAGE]: { id: "" } };
            }
        }
        else {
            this.templates = params.templates;
        }
    }
    get json() {
        return toJSON(this);
    }
    localeTemplate(type, language = DEFAULT_LANGUAGE) {
        try {
            if (!(type in this.templates))
                return { id: "" };
            if (language in this.templates[type])
                return this.templates[type][language];
            return this.templates[type][DEFAULT_LANGUAGE] || { id: "" };
        }
        catch (error) {
            return { id: "" };
        }
    }
}
